import { create } from "zustand";
import { metaApi, type Meta } from "@/api/meta";

interface MetaState {
  meta: Meta | null;
  load: () => Promise<void>;
}

/** Runtime environment metadata from the backend (env, devServer, cloud). */
export const useMeta = create<MetaState>((set, get) => ({
  meta: null,
  load: async () => {
    if (get().meta) return;
    try {
      set({ meta: await metaApi.get() });
    } catch {
      /* leave null — indicators fall back to a neutral state */
    }
  },
}));
